export default {
  PRODUCTS_REPOSITORY: Symbol.for('PRODUCTS_REPOSITORY'),
  GET_PRODUCTS_QUERY: Symbol.for('GET_PRODUCTS_QUERY'),
  PRODUCTS_REPOSITORY_STATE_MANAGER: Symbol.for('PRODUCTS_REPOSITORY_STATE_MANAGER'),
};
